/**
 * Canonical LOTSOG selected-node normalization for client code.
 *
 * Core implementation lives in lotsogSelectedNodesCore.cjs so Functions can
 * import the same source via a CJS adapter. Fixture tests enforce parity.
 */
import lotsogSelectedNodesCore from './lotsogSelectedNodesCore.cjs';

export const {
  normalizeLotsogBriefingMode,
  sanitizeLotsogSelectedNodes,
} = lotsogSelectedNodesCore;

export const lotsogSelectedNodesUtils = {
  sanitizeLotsogSelectedNodes,
};

export default lotsogSelectedNodesUtils;
